(function () {
  var MOBILE_BREAKPOINT = 960;
  var DESKTOP_SPACE_BETWEEN = 140;
  var instances = new WeakMap();
  var restartFrames = new WeakMap();

  var isDesktop = function () {
    return window.matchMedia('(min-width: ' + MOBILE_BREAKPOINT + 'px)').matches;
  };

  var resetMobileEqualCardHeight = function (section) {
    section.style.removeProperty('--custom-journey-mobile-card-height');
  };

  var syncMobileEqualCardHeight = function (section) {
    if (isDesktop()) {
      resetMobileEqualCardHeight(section);
      return;
    }

    var cards = section.querySelectorAll('.custom-journey-carousel__slide-card');

    if (!cards.length) {
      return;
    }

    var maxHeight = 0;

    cards.forEach(function (card) {
      card.style.setProperty('height', 'auto');
      card.style.setProperty('min-height', '0');
    });

    cards.forEach(function (card) {
      maxHeight = Math.max(maxHeight, card.offsetHeight);
    });

    cards.forEach(function (card) {
      card.style.removeProperty('height');
      card.style.removeProperty('min-height');
    });

    if (maxHeight > 0) {
      section.style.setProperty('--custom-journey-mobile-card-height', maxHeight + 'px');
    }
  };

  var resetDesktopSlideBottomHeight = function (section) {
    section.style.removeProperty('--custom-journey-slide-bottom-height');
  };

  var syncDesktopSlideBottomHeight = function (section) {
    if (!isDesktop()) {
      resetDesktopSlideBottomHeight(section);
      return;
    }

    var blocks = section.querySelectorAll('.custom-journey-carousel__slide-bottom');

    if (!blocks.length) {
      return;
    }

    resetDesktopSlideBottomHeight(section);

    var maxHeight = 0;

    blocks.forEach(function (block) {
      block.style.setProperty('height', 'auto');
      block.style.setProperty('min-height', '0');
      block.style.setProperty('flex', '0 0 auto');
    });

    blocks.forEach(function (block) {
      maxHeight = Math.max(maxHeight, block.offsetHeight);
    });

    blocks.forEach(function (block) {
      block.style.removeProperty('height');
      block.style.removeProperty('min-height');
      block.style.removeProperty('flex');
    });

    if (maxHeight > 0) {
      section.style.setProperty('--custom-journey-slide-bottom-height', maxHeight + 'px');
    }
  };

  var syncCarouselHeights = function (section, swiper) {
    if (isDesktop()) {
      resetMobileEqualCardHeight(section);
      syncDesktopSlideBottomHeight(section);

      if (swiper && !swiper.destroyed) {
        swiper.update();
      }
    } else {
      resetDesktopSlideBottomHeight(section);
      syncMobileEqualCardHeight(section);
    }
  };

  var getStartIndex = function (swiper) {
    if (!swiper || swiper.destroyed) {
      return 0;
    }

    if (swiper.params && swiper.params.loop && typeof swiper.realIndex === 'number') {
      return swiper.realIndex;
    }

    return swiper.activeIndex || 0;
  };

  var isCarouselAtStart = function (swiper) {
    if (!swiper || swiper.destroyed) {
      return true;
    }

    return getStartIndex(swiper) === 0;
  };

  var updatePrevNavVisibility = function (section, swiper) {
    var prev = section.querySelector('.custom-journey-carousel__nav--prev');
    var showPrev = !isCarouselAtStart(swiper);

    section.classList.toggle('custom-journey-carousel--show-prev', showPrev);

    if (!prev) {
      return;
    }

    prev.setAttribute('aria-hidden', showPrev ? 'false' : 'true');
    prev.tabIndex = showPrev ? 0 : -1;
  };

  var resetPrevNavVisibility = function (section) {
    var prev = section.querySelector('.custom-journey-carousel__nav--prev');

    section.classList.remove('custom-journey-carousel--show-prev');

    if (prev) {
      prev.removeAttribute('aria-hidden');
      prev.tabIndex = 0;
    }
  };

  var resetNavInlineStyles = function (section) {
    var prev = section.querySelector('.custom-journey-carousel__nav--prev');
    var next = section.querySelector('.custom-journey-carousel__nav--next');

    [prev, next].forEach(function (button) {
      if (!button) {
        return;
      }

      button.style.left = '';
      button.style.right = '';
      button.style.top = '';
      button.style.transform = '';
    });
  };

  var clearSwiperInlineStyles = function (section) {
    var swiperEl = section.querySelector('.custom-journey-carousel__swiper');

    if (!swiperEl) {
      return;
    }

    swiperEl.style.height = '';

    var wrapper = swiperEl.querySelector('.swiper-wrapper');

    if (wrapper) {
      wrapper.style.height = '';
    }
  };

  var forceDestroySwiperElement = function (swiperEl) {
    if (!swiperEl || !swiperEl.swiper) {
      return;
    }

    if (!swiperEl.swiper.destroyed) {
      swiperEl.swiper.destroy(true, true);
    }

    delete swiperEl.swiper;
  };

  var addMediaListener = function (media, handler) {
    if (typeof media.addEventListener === 'function') {
      media.addEventListener('change', handler);

      return function () {
        media.removeEventListener('change', handler);
      };
    }

    if (typeof media.addListener === 'function') {
      media.addListener(handler);

      return function () {
        media.removeListener(handler);
      };
    }

    return null;
  };

  var cancelScheduledRestart = function (section) {
    var frameId = restartFrames.get(section);

    if (frameId) {
      window.cancelAnimationFrame(frameId);
      restartFrames.delete(section);
    }
  };

  var scheduleRestartCarousel = function (section) {
    cancelScheduledRestart(section);

    restartFrames.set(
      section,
      window.requestAnimationFrame(function () {
        restartFrames.set(
          section,
          window.requestAnimationFrame(function () {
            restartFrames.delete(section);
            restartCarousel(section);
          })
        );
      })
    );
  };

  var resetSwiperInlineHeight = function (swiper) {
    if (!swiper || swiper.destroyed) {
      return;
    }

    if (swiper.wrapperEl) {
      swiper.wrapperEl.style.height = '';
    }

    if (swiper.el) {
      swiper.el.style.height = '';
    }
  };

  var initMediaSwiper = function (section) {
    var mediaSwiperEl = section.querySelector('.custom-journey-carousel__media-swiper');

    if (!mediaSwiperEl || !window.Swiper) {
      return null;
    }

    forceDestroySwiperElement(mediaSwiperEl);

    return new Swiper(mediaSwiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 800,
      loop: false,
      allowTouchMove: false,
      simulateTouch: false,
      watchOverflow: true,
    });
  };

  var updateSwiperInstances = function (section, swiper, mediaSwiper) {
    if (mediaSwiper && !mediaSwiper.destroyed) {
      mediaSwiper.update();
    }

    if (swiper && !swiper.destroyed) {
      swiper.update();
    }
  };

  var updateLeftSlideVisibility = function (swiper) {
    if (!swiper || swiper.destroyed) {
      return;
    }

    var activeIndex = getStartIndex(swiper);
    var activeSlide = swiper.slides[activeIndex];
    var activeCenter = null;

    if (activeSlide && isDesktop()) {
      var activeRect = activeSlide.getBoundingClientRect();
      activeCenter = activeRect.left + activeRect.width / 2;
    }

    swiper.slides.forEach(function (slide, index) {
      if (!isDesktop()) {
        slide.classList.remove('custom-journey-carousel__slide--before-active');
        return;
      }

      if (index === activeIndex || activeCenter === null) {
        slide.classList.remove('custom-journey-carousel__slide--before-active');
        return;
      }

      var slideRect = slide.getBoundingClientRect();
      var slideCenter = slideRect.left + slideRect.width / 2;
      var isLeft = slideCenter < activeCenter;

      slide.classList.toggle('custom-journey-carousel__slide--before-active', isLeft);
    });
  };

  var getDesktopSpaceBetween = function (section) {
    var instance = instances.get(section);
    var swiper = instance && instance.swiper;
    var spaceBetween = swiper && !swiper.destroyed ? swiper.params.spaceBetween : DESKTOP_SPACE_BETWEEN;

    if (typeof spaceBetween !== 'number') {
      spaceBetween = DESKTOP_SPACE_BETWEEN;
    }

    return spaceBetween;
  };

  var getMobileDividerAxisCenter = function (section) {
    var referenceSlide = section.querySelector('.custom-journey-carousel__slide');

    if (!referenceSlide) {
      return null;
    }

    var wrap = referenceSlide.querySelector('.custom-journey-carousel__slide-card-wrap');
    var slideTop = referenceSlide.querySelector('.custom-journey-carousel__slide-top');
    var swiperEl = section.querySelector('.custom-journey-carousel__swiper');

    if (!wrap || !slideTop || !swiperEl) {
      return null;
    }

    return swiperEl.offsetTop + slideTop.offsetHeight;
  };

  var updateMobileNavPosition = function (section) {
    var carousel = section.querySelector('.custom-journey-carousel__carousel');
    var axis = section.querySelector('.custom-journey-carousel__axis');
    var prev = section.querySelector('.custom-journey-carousel__nav--prev');
    var next = section.querySelector('.custom-journey-carousel__nav--next');
    var axisCenter = getMobileDividerAxisCenter(section);

    if (!carousel || !prev || !next || axisCenter === null) {
      return;
    }

    var styles = getComputedStyle(section);
    var gap = 8;
    var navInset = parseFloat(styles.getPropertyValue('--custom-journey-mobile-nav-inset')) || 24;
    var spaceOuter = parseFloat(styles.getPropertyValue('--space-outer')) || 0;
    var cardRight = carousel.offsetWidth - spaceOuter - navInset;
    var nextLeft = cardRight - next.offsetWidth;
    var prevLeft = nextLeft - gap - prev.offsetWidth;
    var navTop = carousel.offsetTop + axisCenter;

    if (axis) {
      var sectionRect = section.getBoundingClientRect();
      var carouselRect = carousel.getBoundingClientRect();
      axis.style.top = carouselRect.top - sectionRect.top + axisCenter + 'px';
    }

    prev.style.top = navTop + 'px';
    next.style.top = navTop + 'px';
    prev.style.left = prevLeft + 'px';
    next.style.left = nextLeft + 'px';
    prev.style.right = 'auto';
    next.style.right = 'auto';
    prev.style.transform = 'translateY(-50%)';
    next.style.transform = 'translateY(-50%)';
  };

  var updateNavPosition = function (section) {
    if (!isDesktop()) {
      updateMobileNavPosition(section);
      return;
    }

    var swiperEl = section.querySelector('.custom-journey-carousel__swiper');
    var referenceSlide = section.querySelector('.custom-journey-carousel__slide');
    var prev = section.querySelector('.custom-journey-carousel__nav--prev');
    var next = section.querySelector('.custom-journey-carousel__nav--next');

    if (!swiperEl || !referenceSlide || !prev || !next) {
      return;
    }

    var styles = getComputedStyle(section);
    var navNudge = parseFloat(styles.getPropertyValue('--custom-journey-nav-offset')) || 18;
    var spaceBetween = getDesktopSpaceBetween(section);
    var slideWidth = referenceSlide.offsetWidth;
    var viewportCenter = swiperEl.offsetLeft + swiperEl.offsetWidth / 2;
    var halfGap = spaceBetween / 2;

    prev.style.left =
      viewportCenter - slideWidth / 2 - halfGap - prev.offsetWidth / 2 + navNudge + 'px';
    next.style.left =
      viewportCenter + slideWidth / 2 + halfGap - next.offsetWidth / 2 - navNudge + 'px';
  };

  var destroyCarouselInstance = function (section, instance) {
    cancelScheduledRestart(section);

    if (instance) {
      if (instance.removeBreakpointListener) {
        instance.removeBreakpointListener();
      }

      if (instance.onResize) {
        window.removeEventListener('resize', instance.onResize);
      }

      if (instance.mediaSwiper && !instance.mediaSwiper.destroyed) {
        instance.mediaSwiper.destroy(true, true);
      }

      if (instance.swiper && !instance.swiper.destroyed) {
        instance.swiper.destroy(true, true);
      }

      instances.delete(section);
    }

    forceDestroySwiperElement(section.querySelector('.custom-journey-carousel__swiper'));
    forceDestroySwiperElement(section.querySelector('.custom-journey-carousel__media-swiper'));
    clearSwiperInlineStyles(section);
    resetNavInlineStyles(section);
    resetPrevNavVisibility(section);
    resetMobileEqualCardHeight(section);
    resetDesktopSlideBottomHeight(section);

    var axis = section.querySelector('.custom-journey-carousel__axis');

    if (axis) {
      axis.style.top = '';
    }
  };

  var restartCarousel = function (section) {
    var instance = instances.get(section);
    var startIndex = instance && instance.swiper ? getStartIndex(instance.swiper) : 0;

    destroyCarouselInstance(section, instance);
    initCarousel(section, startIndex);
  };

  var initCarousel = function (section, startIndex) {
    var swiperEl = section.querySelector('.custom-journey-carousel__swiper');

    if (!swiperEl || !window.Swiper) {
      return;
    }

    forceDestroySwiperElement(swiperEl);

    if (swiperEl.swiper) {
      return;
    }

    var paginationEl = section.querySelector('.custom-journey-carousel__pagination');
    var mediaSwiper = initMediaSwiper(section);

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      centeredSlides: true,
      autoHeight: false,
      speed: 800,
      loop: false,
      spaceBetween: 0,
      watchSlidesProgress: true,
      simulateTouch: true,
      grabCursor: true,
      edgeSwipeDetection: true,
      preventClicks: true,
      preventClicksPropagation: true,
      controller: mediaSwiper
        ? {
            control: mediaSwiper,
            by: 'container',
          }
        : undefined,
      breakpoints: {
        960: {
          slidesPerView: 'auto',
          spaceBetween: DESKTOP_SPACE_BETWEEN,
        },
      },
      navigation: {
        nextEl: section.querySelector('.swiper-button-next'),
        prevEl: section.querySelector('.swiper-button-prev'),
      },
      pagination: paginationEl
        ? {
            el: paginationEl,
            type: 'fraction',
            renderFraction: function (currentClass, totalClass) {
              return (
                '<span class="' +
                currentClass +
                '"></span>/<span class="' +
                totalClass +
                '"></span>'
              );
            },
          }
        : undefined,
      on: {
        init: function () {
          this.update();
          updateSwiperInstances(section, this, mediaSwiper);

          if (isDesktop()) {
            resetSwiperInlineHeight(this);
            updateLeftSlideVisibility(this);
            syncCarouselHeights(section, this);
          } else {
            syncCarouselHeights(section, this);
          }

          updateNavPosition(section);
          updatePrevNavVisibility(section, this);
        },
        imagesReady: function () {
          syncCarouselHeights(section, this);
          updateNavPosition(section);
          updatePrevNavVisibility(section, this);
        },
        progress: function () {
          if (isDesktop()) {
            updateLeftSlideVisibility(this);
          }
        },
        slideChange: function () {
          updateLeftSlideVisibility(this);
          updatePrevNavVisibility(section, this);

          if (isDesktop()) {
            updateNavPosition(section);
          }
        },
        slideChangeTransitionStart: function () {
          updateLeftSlideVisibility(this);
          updatePrevNavVisibility(section, this);

          if (isDesktop()) {
            updateNavPosition(section);
          }
        },
        slideChangeTransitionEnd: function () {
          updateLeftSlideVisibility(this);
          updatePrevNavVisibility(section, this);

          if (isDesktop()) {
            updateNavPosition(section);
          }
        },
        resize: function () {
          updateNavPosition(section);
          updatePrevNavVisibility(section, this);
          updateSwiperInstances(section, this, mediaSwiper);
          updateLeftSlideVisibility(this);

          if (isDesktop()) {
            resetSwiperInlineHeight(this);
            syncCarouselHeights(section, this);
            updateNavPosition(section);
            return;
          }

          syncCarouselHeights(section, this);
          updateNavPosition(section);
        },
      },
    });

    var breakpointMedia = window.matchMedia('(min-width: ' + MOBILE_BREAKPOINT + 'px)');
    var onBreakpointChange = function () {
      scheduleRestartCarousel(section);
    };
    var onResize = function () {
      var currentInstance = instances.get(section);

      if (!currentInstance || !currentInstance.swiper || currentInstance.swiper.destroyed) {
        return;
      }

      updateNavPosition(section);
      updatePrevNavVisibility(section, currentInstance.swiper);

      if (isDesktop()) {
        resetSwiperInlineHeight(currentInstance.swiper);
        updateSwiperInstances(section, currentInstance.swiper, currentInstance.mediaSwiper);
        updateLeftSlideVisibility(currentInstance.swiper);
        syncCarouselHeights(section, currentInstance.swiper);
        updateNavPosition(section);
      } else {
        updateSwiperInstances(section, currentInstance.swiper, currentInstance.mediaSwiper);
        syncCarouselHeights(section, currentInstance.swiper);
        updateNavPosition(section);
      }
    };

    var removeBreakpointListener = addMediaListener(breakpointMedia, onBreakpointChange);

    window.addEventListener('resize', onResize);

    instances.set(section, {
      swiper: swiper,
      mediaSwiper: mediaSwiper,
      onBreakpointChange: onBreakpointChange,
      removeBreakpointListener: removeBreakpointListener,
      onResize: onResize,
    });

    updateNavPosition(section);
    updatePrevNavVisibility(section, swiper);

    window.requestAnimationFrame(function () {
      if (swiper.destroyed) {
        return;
      }

      if (typeof startIndex === 'number' && startIndex > 0) {
        swiper.slideTo(startIndex, 0);
      }

      updateNavPosition(section);
      updatePrevNavVisibility(section, swiper);
      updateSwiperInstances(section, swiper, mediaSwiper);

      if (isDesktop()) {
        resetSwiperInlineHeight(swiper);
        updateLeftSlideVisibility(swiper);
        syncCarouselHeights(section, swiper);
        updateNavPosition(section);
        return;
      }

      syncCarouselHeights(section, swiper);
      updateNavPosition(section);
    });

    return swiper;
  };

  var initSections = function (root) {
    var scope = root || document;

    scope.querySelectorAll('[data-custom-journey-carousel]').forEach(function (section) {
      initCarousel(section);
    });
  };

  var destroySections = function (root) {
    var scope = root || document;

    scope.querySelectorAll('[data-custom-journey-carousel]').forEach(function (section) {
      var instance = instances.get(section);

      if (instance) {
        destroyCarouselInstance(section, instance);
      }
    });
  };

  var bootstrap = function () {
    initSections();

    if (window.Swiper) {
      return;
    }

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;

      if (window.Swiper) {
        window.clearInterval(timer);
        initSections();
      } else if (attempts > 50) {
        window.clearInterval(timer);
      }
    }, 100);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSections(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroySections(event.target);
  });
})();
